import React from 'react';
import PropTypes from 'prop-types';

import { SelectFilter } from './Filters/SelectFilter';
import { useBreakpointRef } from '../hooks/useBreakpointRef';

export const SidebarSwitcher = ({ label = '', options, onChange }) => {
  if (!options) return null;
  const BREAKPOINTS = Object.freeze([1080]);
  const BREAKPOINT_VALUES = Object.freeze([true, false]);
  const { breakpointValue } = useBreakpointRef({
    breakpoints: BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES,
    direction: '',
  });

  return (
    <div className="sidebar-role-switcher">
      <SelectFilter
        defaultValue={options[0]}
        isClearable={false}
        {...(breakpointValue ? { size: 'xs' } : {})}
        name="option_switcher"
        iconKey="icon"
        label={label}
        onChange={onChange}
        options={options}
        labelKey="label"
        explainerKey="description"
      />
    </div>
  );
};

SidebarSwitcher.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
};
